export default __webpack_public_path__ + "static/media/Coffee Maker.62b6ec93.png";